import { ClipFilter, LimitFilter, SlideFilter } from '@apeiron/common'
import * as R from 'ramda'
import { useCallback } from 'react'

const useMakeFilter = <T extends unknown>(): Hook<T> => {
  // private
  const makeLimitFilter = useCallback((input: any): LimitFilter => {
    return {
      field: R.propOr('', 'field', input),
      slot: R.propOr(0, 'slot', input)
    }
  }, [])

  // public
  const makeClipFilter = useCallback(
    (input: any, makeValue: (input: any) => T): ClipFilter<T> => {
      return {
        field: R.propOr('', 'field', input),
        image: R.propOr('', 'image', input),
        name: R.propOr('', 'name', input),
        values: R.map(makeValue, R.propOr([], 'values', input))
      }
    },
    []
  )

  // public
  const makeSlideFilter = useCallback(
    (input: any): SlideFilter => {
      return {
        decimalScale: R.propOr(0, 'decimal_scale', input),
        image: R.propOr('', 'image', input),
        name: R.propOr('', 'name', input),
        remark: R.propOr('', 'remark', input),
        step: R.propOr(1, 'step', input),
        min: makeLimitFilter(R.propOr({}, 'min', input)),
        max: makeLimitFilter(R.propOr({}, 'max', input))
      }
    },
    [makeLimitFilter]
  )

  return {
    makeClipFilter,
    makeSlideFilter
  }
}

type Hook<T> = {
  makeClipFilter: (input: any, makeValue: (input: any) => T) => ClipFilter<T>
  makeSlideFilter: (input: any) => SlideFilter
}

export default useMakeFilter
